import { useQuery } from '@apollo/client'

import { reportClientError } from '../../../../../app/_components/chrome/scripts/DataDogRumScript'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { FETCH_KIT_SHOP_THE_LOOK, FetchShopTheLook } from '../../../../../lib/graphql/queries'
import { ProductWithAvailability } from '../../../../../types/graphql'

import type { Props, ViewModel } from './types'

export function useViewModel({ productHandle, isKit = false }: Props): ViewModel {
  const { shopTheLook: shopTheLookStrings } = useTranslation()

  const { data, loading } = useQuery<{
    product?: ProductWithAvailability
    kit?: {
      shopTheLook?: readonly ProductWithAvailability[]
    }
  }>(isKit ? FETCH_KIT_SHOP_THE_LOOK : FetchShopTheLook, {
    onError: error => {
      reportClientError({
        error,
        context: {
          scope: 'Shop the Look Section',
        },
      })
    },
    variables: { handle: productHandle },
  })

  const shopTheLookProducts: readonly ProductWithAvailability[] = isKit
    ? data?.kit?.shopTheLook?.filter(product => product.availableForSale) ?? []
    : data?.product?.shopTheLook?.nodes?.filter(node => node.availableForSale) ?? []

  return {
    headline: shopTheLookStrings.headline,
    loading,
    shopTheLookProducts,
  }
}
